// @flow
import * as React from 'react';
import { ReactComponent as Icon } from 'esm-web-pro/assets/images/table/filter.svg';
import styled from 'styled-components';

const Filter = styled(Icon)`
  height: 18px;
  width: 18px;
`;

export default Filter;
